import styled from '@emotion/styled'

export const ContentContainer = styled.div`
  min-height: 96px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    min-height: auto;
  }
`
